var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.192 20.499c-.507.626-.82.781-1.192.781a1.26 1.26 0 0 1-.955-.43zM9 .72c.252 0 .463.07.619.241a.966.966 0 0 1 .246.678v1.347c1.822.437 3.022 1.199 3.963 2.402.904 1.158 1.355 2.482 1.355 3.973v6.315l2.097 2.22-16.56.105 2.097-2.325V9.374c.064-1.668.508-2.901 1.355-3.986 1.02-1.304 2.339-2.096 3.963-2.372v-1.35c.025-.326.092-.535.246-.705C8.537.791 8.748.72 9 .72z",
    fill: "#F6B119",
    fillRule: "nonzero",
    stroke: "#F6B119",
    strokeWidth: 1.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOrange);
export default __webpack_public_path__ + "static/media/notification-orange.9bbc8fc4f3b99a34edf367ea82531f15.svg";
export { ForwardRef as ReactComponent };